import React from 'react';
import { Link } from 'react-router-dom';
import { subscription_info } from '../../../routes';
import SubscriptionStatus from '../../../components/SubscriptionStatus';
import cls from './SubscriptionCard.module.scss';

export default function SubscriptionCard(props) {

    const unlimited = props.data.attributes.unlimited;
    const limit = props.data.attributes.limit !== undefined ? props.data.attributes.limit : 0;
    const visitCount = props.data.attributes.visitCount !== undefined ? props.data.attributes.visitCount : 0;
    
    return (
        <Link to={subscription_info(props.id)} className={cls.card} key={props.id}>
            <h3># {props.id}</h3>

            <div>
                    <div>
                        {props.data?.attributes?.gym?.data?.attributes?.name}
                        {props.data?.attributes?.gym?.data?.attributes?.address && `, ${props.data.attributes.gym.data.attributes.address}`}
                    </div>

                <div className={cls.status}>
                    <SubscriptionStatus
                        type={'date'}
                        size={'small'}
                        startDate={props.data.attributes.startDate}
                        endDate={props.data.attributes.endDate}
                    />

                    <SubscriptionStatus
                        type={'limit'}
                        size={'small'}
                        unlimited={unlimited}
                        limit={limit}
                        visitCount={visitCount}
                    />

                    <SubscriptionStatus type={'payment'} size={'small'} paid={props.data.attributes.paid} />
                </div>
            </div>
        </Link>
    );
}
